import React from 'react';
import QuoteStore from '../../../../stores/QuoteStore';

interface Params {
    setLoading: (v: boolean) => void;
    setErrorPartId: (v: number | null) => void;
    setErrorStepId: (v: number | null) => void;
    setScrollTick: React.Dispatch<React.SetStateAction<number>>;
}

export const useValidationErrorsHandlers = ({ setLoading, setErrorPartId, setErrorStepId, setScrollTick }: Params) => {
    const handleQuoteValidationErrors = () => {
        const error = QuoteStore.errorFields?.[0];
        if (!error) {
            setErrorPartId(null);
            return;
        }

        const lineItemId = Number(error.lineItem);
        const stepId = error.step;

        if (stepId) {
            setErrorStepId(stepId);
        }

        if (lineItemId) {
            setLoading(false);
            setErrorPartId(lineItemId);
            setScrollTick(v => v + 1);
            QuoteStore.setExpandedPartId(Number(error.lineItem));
        }
    };

    return {
        handleQuoteValidationErrors,
    };
};
